export default __webpack_public_path__ + "static/media/eu-cut-out-area-boudaries-map.eb5967b7.jpg";